module.exports = __webpack_public_path__ + "static/img/fdmPurpose4.7dfd017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdmPurpose4.png
// module id = GrjA
// module chunks = 2